import Vue from "vue";
import Router from "vue-router";
import routerMoblie from "./moblie";
import $store from "@/store";
import toLogin from "@libs/login";
import { isH5 } from "@utils";

// PC端
import routerPc from "./pc";

Vue.use(Router);
if (isH5()) {
  var router = new Router({
    mode: "history",
    routes: routerMoblie,
    scrollBehavior(to, from) {
      from.meta.scrollTop = window.scrollY;
      return { x: 0, y: to.meta.scrollTop || 0 };
    }
  });

  const { back, replace } = router;

  router.back = function() {
    this.isBack = true;
    back.call(router);
  };
  router.replace = function(...args) {
    this.isReplace = true;
    replace.call(router, ...args);
  };

  router.beforeEach((to, form, next) => {
    const { title, backgroundColor, footer, home, auth } = to.meta;
    console.log(to.name, form.name);
    if (auth === true && !$store.state.app.token) {
      if (form.name === "Login") return;
      return toLogin(true, to.fullPath);
    }
    document.title = title || process.env.VUE_APP_NAME || "樂托品";
    //判断是否显示底部导航
    footer === true
      ? $store.commit("SHOW_FOOTER")
      : $store.commit("HIDE_FOOTER");

    //控制悬浮按钮是否显示
    home === false ? $store.commit("HIDE_HOME") : $store.commit("SHOW_HOME");

    $store.commit("BACKGROUND_COLOR", backgroundColor || "#F5F5F5");

    if (auth) {
      $store.dispatch("USERINFO").then(() => {
        next();
      });
    } else next();
  });
} else {
  // PC端路由
  router = new Router({
    mode: "history",
    scrollBehavior() {
      return {
        x: 0,
        y: 0
      };
    },
    routes: routerPc
  });

  router.beforeEach((to, form, next) => {
    const auth = to.meta.auth;
    if (
      auth === true &&
      !($store.state.token || sessionStorage.getItem("token"))
    ) {
      if (form.name === "Login") return;
      return toLogin(true, to.fullPath);
    }
    document.title = to.meta.title || process.env.VUE_APP_NAME;
    next();
  });
}

export default router;
